module.exports = __webpack_public_path__ + "static/media/normal.037ccd2e.jpg";